<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-dollar mr-2" />Pembayaran Invoice</h5>
            <hr />
            <b-row>
                <b-col md="6">
                    No. Invoice <strong>{{ data.no_faktur }}</strong><br />
                    Invoice untuk <strong>{{ data.customer_name }}</strong><br />
                    Status Invoice: <strong>{{ data.status == 2 ? "Ongoing" : data.status == 3 ? "Lunas" : "Error" }}</strong><br />
                    Total Piutang: <strong>Rp. {{ $helper.formatThousand(data.total) }}</strong><br />
                    Sisa Pembayaran: <strong>Rp. {{ $helper.formatThousand(data.outstanding_payment) }}</strong>
                    <!-- {{ data.total_item }} barang, total Rp. {{ $helper.formatThousand(data.total_price) }} -->
                </b-col>
                <b-col md="6" class="text-right">
                    <b-button v-if="data.status == 2" variant="success" @click="$bvModal.show('m-create-payment')">
                        <i class="fa fa-plus mr-2" />Pembayaran Baru
                    </b-button>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :items="data.payments"
                :fields="fields"
                responsive class="my-3"
                @sort-changed="onSortChanged"
            >
                <template v-slot:empty>
                    Belum ada pembayaran.
                </template>
                <template v-slot:cell(amount)="row">
                    Rp. {{ $helper.formatThousand(row.item.amount) }}
                </template>
                <template v-slot:cell(type)="row">
                    <b-badge v-if="row.item.type == 1" variant="primary">PEMBAYARAN</b-badge>
                    <b-badge v-else-if="row.item.type == 2" variant="warning">RETUR</b-badge>
                    <b-badge v-else variant="light">-</b-badge>
                </template>
                <template v-slot:cell(created_by_at)="row">
                    {{ row.item.created_by }}
                    <div class="small text-muted">
                        {{ $helper.parseDate(row.item.created_at) }}, {{ $helper.parseHourMinute(row.item.created_at) }}
                    </div>
                </template>
                <template v-slot:cell(note)="row">
                    {{ row.item.note || "-" }}
                </template>
            </b-table>
        </b-card>
        <b-modal id="m-create-payment" title="Pembayaran Baru" centered hide-footer no-close-on-backdrop no-close-on-esc>
            Membuat pembayaran baru untuk Invoice {{ data.no_faktur }}.<br />
            Sisa pembayaran: <strong>Rp. {{ $helper.formatThousand(data.outstanding_payment) }}</strong>

            <b-form-group label="Jumlah Pembayaran" class="mt-4">
                <b-input v-model="input.amount" maxlength="20" />
            </b-form-group>
            <b-form-group label="Catatan Pembayaran">
                <b-input v-model="input.note" maxlength="150" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="createPayment">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan Pembayaran" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,
            isFetching: false,

            input: {
                amount: "",
                note: ""
            },

            data: {
                payments: []
            },

            fields: [
                { key: "no", label: "No." },
                { key: "amount", label: "Jumlah Pembayaran" },
                { key: "type", label: "Tipe Pembayaran" },
                { key: "created_by_at", label: "Eksekutor" },
                { key: "note", label: "Catatan" }
            ],

            sortBy: null,
            sortDesc: false,

        }
    },

    watch: {

        "input.amount": function(newVal) {

            let cleaned = String(newVal).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.$nextTick(() => this.input.amount = res)

        }

    },

    methods: {

        init() {

            this.initStatus = 0

            let getData = this.getItems()

            Promise.all([getData]).then(() => {
                this.initStatus = 1
            })
            .catch(error => this.initStatus = -1)

        },
        
        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        getItems() {
            return this.$axios.get("invoice/payments/" + this.$route.params.id).then(res => {
                this.data = res.data.data
            })
            .catch(error => this.$helper.parseError(this, error))
        },

        createPayment() {

            if(this.$helper.isBlank(this.input.amount)) {
                return this.$helper.toastError(this, "Mohon mengisi jumlah pembayaran!")
            }

            if(this.$helper.isBlank(this.input.note)) {
                return this.$helper.toastError(this, "Mohon mengisi catatan pembayaran!")
            }

            let isConfirmed = confirm("Transaksikan pembayaran ini?")
            if(!isConfirmed) return

            this.isSubmitting = true

            let payload = {
                id: this.$route.params.id,
                amount: this.$helper.toNumber(this.input.amount),
                note: this.input.note
            }

            this.$axios.post("invoice/create-payment", payload).then(res => {

                this.$helper.toastSuccess(this, "Pembayaran berhasil disimpan!")
                this.$bvModal.hide("m-create-payment")
                this.input.amount = ""
                this.input.note = ""
                this.init()

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        }

    },
    created() {
        this.init()
    }
}
</script>
